export const getLoading = state => state.loading;



// WEBPACK FOOTER //
// ./src/redux/email/selectors.js